import { SET_SMART_IS_VISIBLE } from './constants';

export const setSMARTisVisible = isVisible => ({
    type: SET_SMART_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/SMART/actions.js